import { DataTypes } from "../../../Common/Data/DataTypes";
import { BaseJSONXMLElement } from "./BaseJSONXMLElement";

export class JSONXMLNumberElement extends BaseJSONXMLElement {
    readonly __type: string = "jsonnumber";
    readonly name: string = "Number Value";
    readonly ordinal: number = 1;
    readonly outputType: DataTypes = DataTypes.NUMBER;
    readonly styleElement: boolean = false;
}
